const ZegoMenuBarStyle = {
    light: 0,
    dark: 1
}

export default ZegoMenuBarStyle;